import { Card } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';

// import { formatPhone } from '@utils/format';
import * as ROUTES from '@constants/routes';

import type { LegalDirectiveRecord } from '@models/legal-directive';

import { SectionH2 } from '../HealthSummary.style';
import DirectivesEntry from './DirectivesEntry';

const messages = defineMessages({
  directives: {
    id: 'directives.title',
    defaultMessage: 'directives',
  },
  organDonor: {
    id: 'directives.organDonation',
    defaultMessage: 'Organ Donation',
  },
  approvedOrgans: {
    id: 'directives.approvedOrgans',
    defaultMessage: 'Willing to donate:',
  },
  bloodProducts: {
    id: 'directives.bloodProducts',
    defaultMessage: 'Blood Products',
  },
  approvedBlood: {
    id: 'directives.approvedBlood',
    defaultMessage: 'Accepts these blood products:',
  },
  heroicMeasures: {
    id: 'directives.heroicMeasures',
    defaultMessage: 'Heroic Measures',
  },
  approvedHeroic: {
    id: 'directives.approvedHeroic',
    defaultMessage: 'Accepts these heroic measures:',
  },
});

interface DirectivesProps {
  legal_directives?: LegalDirectiveRecord[];
  clickable?: boolean;
  loading?: boolean;
}

function Directives({
  clickable = true,
  loading = false,
  legal_directives = [],
}: DirectivesProps) {
  const { formatMessage } = useIntl();

  const heroicDirective = legal_directives.find((d) => d.isHeroicMeasures());
  const organDirective = legal_directives.find((d) => d.isOrganDonation());
  const bloodDirective = legal_directives.find((d) => d.isBloodProducts());

  return (
    <Card sx={{ p: 2.5 }}>
      <ContentLoader loading={loading}>
        <>
          <SectionH2>
            {formatMessage(messages.directives).toUpperCase()}
          </SectionH2>

          <DirectivesEntry
            clickable={clickable}
            data={organDirective?.getDirectiveText('specific-organs') ?? []}
            route={ROUTES.ORGAN_DONATION}
            subtitle={formatMessage(messages.approvedOrgans)}
            title={formatMessage(messages.organDonor)}
          />

          <DirectivesEntry
            clickable={clickable}
            data={bloodDirective?.getDirectiveText('blood-products') ?? []}
            route={ROUTES.BLOOD_PRODUCTS}
            subtitle={formatMessage(messages.approvedBlood)}
            title={formatMessage(messages.bloodProducts)}
          />

          <DirectivesEntry
            clickable={clickable}
            data={heroicDirective?.getDirectiveText('heroic-measures') ?? []}
            route={ROUTES.HEROIC_MEASURES}
            subtitle={formatMessage(messages.approvedHeroic)}
            title={formatMessage(messages.heroicMeasures)}
          />
        </>
      </ContentLoader>
    </Card>
  );
}

export default Directives;
